import type { Roll } from "../model/dice/Roll.js";
import type { Move } from "../model/Move.js";
import type { Engine } from "../engine/Engine.js";
import type { RolledGameState } from "../engine/state/RolledGameState.js";
import type { MovedGameState } from "../engine/state/MovedGameState.js";
import type { WaitingForRollGameState } from "../engine/state/WaitingForRollGameState.js";
import type { WaitingForMoveGameState } from "../engine/state/WaitingForMoveGameState.js";
import type { PlayerType } from "../model/PlayerType.js";
import type { EndGameState } from "../engine/state/EndGameState.js";
import type { ResignedGameState } from "../engine/state/ResignedGameState.js";
import type { AbandonedGameState } from "../engine/state/AbandonedGameState.js";
import type { AbandonReason } from "../model/AbandonReason.js";


/**
 * Produces game states from serialised information.
 */
export abstract class StateSource {
    abstract createRolledState(
        rules: Engine,
        timeSinceGameStartMs: number,
        turn: PlayerType,
        roll: Roll,
    ): RolledGameState;

    abstract createMovedState(
        rules: Engine,
        timeSinceGameStartMs: number,
        turn: PlayerType,
        roll: Roll,
        move: Move,
    ): MovedGameState;

    abstract createWaitingForRollState(
        rules: Engine,
        timeSinceGameStartMs: number,
        turn: PlayerType,
    ): WaitingForRollGameState;

    abstract createWaitingForMoveState(
        rules: Engine,
        timeSinceGameStartMs: number,
        turn: PlayerType,
        roll: Roll,
    ): WaitingForMoveGameState;

    abstract createResignedState(
        rules: Engine,
        timeSinceGameStartMs: number,
        player: PlayerType,
    ): ResignedGameState;

    abstract createAbandonedState(
        rules: Engine,
        timeSinceGameStartMs: number,
        reason: AbandonReason,
        player: PlayerType | null,
    ): AbandonedGameState;

    abstract createEndState(
        rules: Engine,
        timeSinceGameStartMs: number,
        winner: PlayerType | null,
    ): EndGameState;
}
